export const { REACT_APP_API_BASE_URL } = process.env;
export const { REACT_APP_TOP_NAVIGATION } = process.env;
export const { REACT_APP_LANDING } = process.env;
export const { REACT_APP_FOOTER } = process.env;
export const { REACT_APP_SEARCH } = process.env;
